import { render, staticRenderFns } from "./UserTabEkpaideusi.vue?vue&type=template&id=2d471635"
import script from "./UserTabEkpaideusi.vue?vue&type=script&lang=js"
export * from "./UserTabEkpaideusi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports